import React from "react";
import Select from "react-select";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Card } from "react-bootstrap";
import { useState } from "react";
import { Modal } from "reactstrap";
import { useNavigate } from "react-router-dom";
import "../templatelist/templatelist.css";
import { useEffect } from "react";
import { apiCall, failedMessage } from "../../utils/httpClient";
import apiEndPoint from "../../utils/apiEndPoint";
import "../categories/categories.css";
import { NavDropdown, Dropdown } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Header from "../../layout/header";
import Footer from "../../layout/footer";

function Templatelist() {
  const [templatesList, setTemplatesList] = useState([]);
  const [base_url, setbaseurl] = useState([]);
  const [categories, setCategories] = useState([]);
  const [offset, setOffset] = useState(0)
  const [limit, setLimit] = useState(8)
  useEffect(() => {
    getCategoryList()
    getTemplatesList()
  }, []);
  const getCategoryList = async () => {
    const { data } = await apiCall('post', apiEndPoint.GETCATEGORY);
    if (data.status === 200) {
      setCategories(data.data)
    } else {
      failedMessage(data.message);
    }
  }
  const getTemplatesList = async (item) => {
    let params = { limit: limit, offset: offset }
    if (item != undefined) {
      params['category_id'] = item
    }
    const { data } = await apiCall('post', apiEndPoint.GETTEMPLATE, params);
    console.log(data)
    if (data.status === 200) {
      setTemplatesList(data.data)
      setbaseurl(data.base_url)
    }
    else {
      setTemplatesList([])
      failedMessage(data.message);
    }
  }
  const options = [
    { value: "All Categories", label: "All Categories" },
    { value: "Author", label: "Author" },
    { value: "Personal Resume", label: "Personal Resume" },
  ];
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenOne, setIsOpenOne] = useState(false);
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };
  
  const navigate = useNavigate();
  return (
    <>
      <Modal
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        style={customStyles}
        contentLabel="Example Modal"
        className="img-modal"
      >
        <div>
          <div className="content text-center"><div className="crds-btn"><button type="button" className="btn btn-light" onClick={() => setIsOpenOne(true)}><i className="fa fa-mobile-alt"></i>Mobile</button></div></div>
        </div>
        <div className="fl-right" onClick={() => setIsOpen(false)}>
          <i className="fa fa-times" aria-hidden="true"></i>
        </div>
        <div className="portimg-crd">
          <iframe id="inlineFrameExample"
            title="Inline Frame Example" className="weblayout-iframe"
            src="https://mydigitalindia.app/DigitalIndiaAppApi/upload/theme/resume5/">
          </iframe>
        </div>
        <button className="btn select-btn" onClick={() => {
          navigate("/templateform");
        }}>
          Select
        </button>
      </Modal>
      <Modal
        isOpen={isOpenOne}
        onRequestClose={() => setIsOpenOne(false)}
        style={customStyles}
        contentLabel="Example Modal"
        className="img-modaltwo"
      >
        <div>
          <div className="content text-center"><div className="crds-btn"><button type="button" className="btn btn-light" onClick={() => setIsOpenOne(false)}><i className="fa fa-desktop"></i> Web</button></div></div>
        </div>
        <div className="portimg-crd">
          <iframe id="inlineFrameExample"
            title="Inline Frame Example" className="weblayout-iframe"
            src="https://mydigitalindia.app/DigitalIndiaAppApi/upload/theme/resume5/">
          </iframe>
        </div>
        <button className="btn select-btn" onClick={() => {
          navigate("/templateform");
        }}>
          Select
        </button>
      </Modal>
      <section className="portfolio-section">
        <div className="container">
          <div className="portfolio-txt">
            <h4>Yourself/Personal Portfolio :</h4>
            <div className="primary-txt">
              See the thousands of solutions we have built for you !
            </div>
            <div className="srch-cat">
              <Select placeholder="Search your categories" options={categories}
                getOptionLabel={(val) => val.category_name}
                getOptionValue={(val) => val._id}
              />
            </div>
            <Tabs>
              <TabList>
                <Tab onClick={() => getTemplatesList()}>All</Tab>
                {categories && categories.map((item, index) => (
                  <Tab eventKey="tab1" key={index} onClick={() => getTemplatesList(item._id)} >{item.category_name}</Tab>
                ))}
              </TabList>
              <TabPanel>
                <h6 className="primary-txt" onClick={() => {
                  navigate("/templatelist");
                }}></h6>
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </section>
      <section className="portfolio-carousel">
        <div className="container">
          <div className="row"> {templatesList.length > 0 && templatesList.map((item, index) => (
            <div className="col-lg-3" key={index}>
              <Card className="port-crd" onClick={() => { setIsOpen(true); localStorage.setItem('selectTemplate', JSON.stringify(item)) }}>
                <Card.Text>
                  <img className="w-100" src={base_url + item.thumbnail} alt="" />
                </Card.Text>
                <Card.Title className="port-txt">
                  {item.title}
                </Card.Title>
                <Card.Text className="port-desc">
                  {item.description}
                </Card.Text>
              </Card>
            </div>
          ))}
          </div>
        </div>
      </section>
      <hr />
    </>
  );
}
export default Templatelist;